<template>
  <div>
    <h1>Game Edit</h1>

    <div class="row">
      <div class="small-6 columns"><div>Name</div></div>
      <div class="small-6 columns">
        <input v-model="gameObj.name" type="text" />
      </div>
    </div>

    <div class="row">
      <div class="small-3 columns">Points</div>
      <div class="small-9 columns" style="position:relative;z-index:10000">
        <input id="" v-model="points" type="number" name="" />
      </div>
    </div>

    <div class="row" style="margin-top:20px">
      <div class="small-6 columns"><div>Time Allocated</div></div>
      <div class="small-6 columns">
        <input v-model="gameObj.time_allocated" type="text" />
      </div>
    </div>
    <div class="row" style="margin-bottom:20px">
      <div class="small-6 columns"><div>Is Time Bound</div></div>
      <div class="small-6 columns">
        <input v-model="gameObj.is_time_bound" type="checkbox" />
      </div>
    </div>

    <div class="row">
      <div class="small-3 columns">Tags</div>
      <div class="small-9 columns" style="position:relative;z-index:10000">
        <VueSelect
          v-model="selectedTags"
          :options="tagOptions"
          label="name"
          multiple
        />
      </div>
    </div>

    <div class="row">
      <div class="small-6 columns">
        <div>Script File</div>
        <div><sub>please upload a minified+ uglified js file</sub></div>
      </div>
      <div class="small-6 columns">
        <SingleFileUpload
          @codingFileUploadSuccess="catchFileUploadSuccess($event)"
        />
      </div>
    </div>

    <div class="row">
      <div class="small-12 columns"><h3>Game Config</h3></div>
      <div class="row">
        <div class="small-12 columns">
          <h5>Choose Framework your game is developed in</h5>
        </div>
        <div>
          <button class="button-red" @click="resetFrameworks">
            Reset All Frameworks
          </button>
        </div>
        <div class="small-6 columns">Framework</div>
        <div class="small-6 columns">
          <h4 v-if="gameObj.game_config_json.links.length === 0">
            No Links added yet
          </h4>
          <div v-for="(game, i) in gameObj.game_config_json.links" :key="i">
            <div class="row">
              <div class="small-6 columns">
                <input
                  v-model="gameObj.game_config_json.links[i]"
                  type="text"
                  style="width:100%"
                />
              </div>
              <div class="small-6 columns">
                <button class="button-red" @click="removeFramework(i)">
                  Delete Script
                </button>
              </div>
            </div>
          </div>
        </div>
        <div><button @click="addFramework">Add Framework</button></div>
        <br />
      </div>
    </div>
    <div class="row">
      <div class="small-6 columns"><div>Instructions Video URL</div></div>
      <div class="small-6 columns">
        <input
          v-model="gameObj.game_config_json.instructions_video_url"
          type="text"
        />
      </div>
    </div>
    <div class="row">
      <div class="small-12 columns">
        <div class="small-6 columns">
          <markdown-editor
            ref="editormarkdown"
            v-model="gameObj.game_config_json.instructions_markdown"
          />
        </div>
        <div class="small-6 columns">
          <div style="padding:16px;" class="markdown-body">
            <vue-markdown
              :source="gameObj.game_config_json.instructions_markdown"
              @rendered="captureMarkdownRenderedHtml($event)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="small-12 columns">
        <button class="button-blue" @click="edit">Edit Game</button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import VueMarkdown from "vue-markdown"
import SingleFileUpload from "@/components/shared/fileUpload/GameUpload"
import siteConfig from "@/utils/siteConfig"
import markdownEditor from "@/components/questions/MarkdownReadingEditor"

export default {
  components: { SingleFileUpload, VueSelect, VueMarkdown, markdownEditor },
  data() {
    return {
      selectedFramework: undefined,
      gameObj: {
        name: "",
        type: 5,
        time_allocated: 0,
        is_time_bound: false,
        game_script_file_id: "",
        game_config_json: {
          links: [],
          instructions_video_url: "",
          instructions_markdown: "",
          instructions_html_b64: "",
        },
      },
      frameworks: [
        {
          name: "PixiJS - 4.8.1",
          link:
            "https://cdnjs.cloudflare.com/ajax/libs/pixi.js/4.8.1/pixi.min.js",
        },
        {
          name: "Phaser - 2.6.2",
          link:
            "https://cdnjs.cloudflare.com/ajax/libs/phaser/2.6.2/phaser.min.js",
        },
      ],
      points: 0,
      selectedTags: [],
      tagOptions: [],
      tags: [],
      qtags: [],
    }
  },
  mounted() {
    this.populateTags()

    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}questions/${this.$route.params.id}`,

      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
    }).then(res => {
      this.gameObj = res.data.data
      window.pageTitle = `Edit - ${this.gameObj.name}`
      if (
        this.gameObj &&
        this.gameObj.game_config_json &&
        this.gameObj.game_config_json.instructions_markdown
      ) {
        this.content = this.gameObj.game_config_json.instructions_markdown
      }
      this.points = res.data.data.points
      if (this.gameObj.game_config_json.links === undefined) {
        this.gameObj.game_config_json.links = []
      }
      // /////////////////////////
      this.qtags = this.gameObj.qtags
      this.selectedTags = this.gameObj.qtags.map(item => ({
        id: item.id,
        name: item.name,
      }))
    })
  },
  methods: {
    captureMarkdownRenderedHtml(outHtml) {
      this.gameObj.game_config_json.instructions_html_b64 = btoa(outHtml)
    },
    resetFrameworks() {
      this.gameObj.game_config_json.links.splice(
        0,
        this.gameObj.game_config_json.frameworks.length
      )
      this.addFramework()
      this.$forceUpdate()
    },
    removeFramework(i) {
      this.gameObj.game_config_json.links.splice(i, 1)
      this.$forceUpdate()
    },
    addFramework() {
      this.gameObj.game_config_json.links.push("")

      this.$forceUpdate()
    },
    catchFileUploadSuccess(event) {
      this.gameObj.game_script_file_id = event.id
    },
    populateTags() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}qtags/?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        const tags = res.data.items
        this.tagOptions = tags.map(item => ({ id: item.id, name: item.name }))
      })
    },
    getDeletedTags() {
      const deletedTags = []
      for (let i = 0; i < this.qtags.length; i++) {
        if (
          !this.findElementInArray(
            this.qtags[i].name,
            this.selectedTags.map(item => item.name)
          )
        ) {
          deletedTags.push(this.qtags[i])
        }
      }
      const finalTags = []
      for (let i = 0; i < deletedTags.length; i++) {
        finalTags.push(deletedTags[i].id)
      }
      return finalTags
    },
    getAddedTags() {
      const addedTags = []

      for (let i = 0; i < this.selectedTags.length; i++) {
        if (
          !this.findElementInArray(
            this.selectedTags[i].name,
            this.qtags.map(item => item.name)
          )
        ) {
          addedTags.push(this.selectedTags[i])
        }
      }
      const finalTags = []
      for (let i = 0; i < addedTags.length; i++) {
        finalTags.push(addedTags[i].id)
      }
      return finalTags
    },
    findElementInArray(element, array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i] === element) {
          return true
        }
      }
      return false
    },
    edit() {
      this.gameObj.ops_qtags_unlink = this.getDeletedTags()
      this.gameObj.ops_qtags = this.getAddedTags()
      this.gameObj.points = this.points
      this.axios({
        method: "put",
        url: `${siteConfig.siteURL}questions/${this.$route.params.id}`,
        data: this.gameObj,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.$router.push("/game/")
      })
    },
  },
}
</script>
